/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$r as $r,
  rec_AccionAsync as AccionAsync,
  rec_AccionesEstadoTarea as AccionesEstadoTarea,
  rec_Ar as Ar,
  rec_BuscadorPersona as BuscadorPersona,
  rec_Bx as Bx,
  rec_Componente_BS_66_83 as Componente_BS_66_83,
  rec_Componente_LS_76_83 as Componente_LS_76_83,
  rec_Componente_zS_122_83 as Componente_zS_122_83,
  rec_ConfirmarFechaTerminada as ConfirmarFechaTerminada,
  rec_EditorMenciones as EditorMenciones,
  rec_FS as FS,
  rec_Fo as Fo,
  rec_Fx as Fx,
  rec_Go as Go,
  rec_Ix as Ix,
  rec_JS as JS,
  rec_JSXRuntime as JSXRuntime,
  rec_ListaAdjuntos as ListaAdjuntos,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_NS as NS,
  rec_Nr as Nr,
  rec_Nx as Nx,
  rec_PS as PS,
  rec_Qx as Qx,
  rec_React as React,
  rec_ResumenTarea as ResumenTarea,
  rec_Ro as Ro,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Yi as Yi,
  rec_Yx as Yx,
  rec_api as api,
  rec_fS as fS,
  rec_ko as ko,
  rec_lS as lS,
  rec_obtenerUsuario as obtenerUsuario,
  rec_oi as oi,
  rec_pS as pS,
  rec_rS as rS,
  rec_ra as ra,
  rec_usuarioIdSesion as usuarioIdSesion,
  rec_wr as wr,
  rec_yr as yr,
  rec_zo as zo,
  rec_zx as zx,
} from "../../runtime/index.jsx";
export function DetalleTarea({
  proyecto: e,
  tarea: t,
  preset: n,
  metas: r = [],
  etiquetas: i = [],
  listas: a = [],
  tareasProyecto: o = [],
  onClose: s,
  onGuardado: c,
  encabezadoExtra: l = null,
}) {
  let [u, f] = (0, React.useState)(t);
  (0, React.useEffect)(() => {
    f(t);
  }, [t]);
  let p = !!u,
    { confirmar: m, pedirTexto: h } = Fo(),
    g = Go(),
    [_, v] = (0, React.useState)(() => (u ? JS(u) : FS(e, n))),
    y = !e.id,
    [b, x] = (0, React.useState)([]),
    [S, C] = (0, React.useState)([]),
    [w, T] = (0, React.useState)(``),
    [E, D] = (0, React.useState)([]),
    [O, k] = (0, React.useState)(``),
    [A, j] = (0, React.useState)(!1),
    M = e.miRol === `OBSERVADOR`,
    N = p && (u.estado === `COMPLETADA` || u.estado === `CANCELADA`),
    P = M || N,
    F = e.miembros ?? [],
    I = usuarioIdSesion(),
    L = p && (u.creadoPorUsuarioId === I || e.miRol === `ADMIN`),
    R = p && (u.asignados ?? []).some((e) => e.usuarioId === I),
    z = p && (L || !!u.puedoMandar),
    ee = p && !z && !R,
    te =
      p &&
      (e.esMiEspacioPersonal ||
        (u.creadoPorUsuarioId === I &&
          (u.asignados ?? []).every((e) => e.usuarioId === I))),
    B = p && R && !!u.necesitaConforme && !z && !N,
    V = P || B || ee,
    [H, ne] = (0, React.useState)([]);
  (0, React.useEffect)(() => {
    let t = e.id ? `proyecto=${e.id}` : `unidad=${e.unidadId}`;
    (e.id || e.unidadId) &&
      api(`/tareas/superiores?${t}`)
        .then((e) => ne(e ?? []))
        .catch(() => {});
  }, [e.id, e.unidadId]);
  let [re, ie] = (0, React.useState)(u?.comprobantes ?? []),
    [U, ae] = (0, React.useState)([]),
    [oe, se] = (0, React.useState)([]),
    [ce, le] = (0, React.useState)(!1),
    [ue, de] = (0, React.useState)(``),
    [fe, pe] = (0, React.useState)(``),
    [me, he] = (0, React.useState)(null),
    [ge, _e] = (0, React.useState)(null),
    ve = U.find((e) => e.estado === `PENDIENTE`);
  ((0, React.useEffect)(() => {
    u &&
      (api(`/tareas/${u.id}/comentarios`)
        .then(C)
        .catch(() => {}),
      api(`/tareas/${u.id}/solicitudes-fecha`)
        .then(ae)
        .catch(() => {}));
  }, [u]),
    (0, React.useEffect)(() => {
      ce &&
        u &&
        api(`/tareas/${u.id}/auditoria`)
          .then(se)
          .catch(() => {});
    }, [ce, u]));
  let ye = (e, t) =>
      v((n) => ({
        ...n,
        [e]: t,
      })),
    be = obtenerUsuario()?.nombre,
    xe = (0, React.useRef)(!1);
  async function Se(e) {
    if (!xe.current) {
      ((xe.current = !0), k(``));
      try {
        (await e(), c(), s());
      } catch (e) {
        k(e.message);
      } finally {
        xe.current = !1;
      }
    }
  }
  let Ce = (e, t = null) =>
      Se(async () => {
        let n = await api(`/tareas/${u.id}/mover`, {
            method: `POST`,
            body: JSON.stringify({
              estado: e,
              realizadaEl: t,
              actorNombre: be,
            }),
            descripcion: `«${u.titulo}» → ${Yx(e)}`,
          }),
          r = n?.estado ?? e;
        n?.guardadoSinConexion
          ? g.ok(`Guardado en el teléfono — se envía al volver la señal`)
          : r === `EN_REVISION`
            ? g.logro(
                `Trabajo terminado`,
                `${u.titulo} — queda esperando el visto bueno`,
              )
            : r === `COMPLETADA`
              ? g.logro(`Tarea completada`, u.titulo)
              : r === `EN_PROGRESO` && g.info(`Tarea retomada`);
      }),
    we = async () => {
      if (!xe.current) {
        ((xe.current = !0), k(``));
        try {
          let e = await api(`/tareas/${u.id}/conforme`, {
            method: `POST`,
            body: JSON.stringify({
              actorNombre: be,
            }),
          });
          (e?.id && f(e), g.logro(`Tarea aprobada`, u.titulo), c());
        } catch (e) {
          k(e.message);
        } finally {
          xe.current = !1;
        }
      }
    },
    Te = async () => {
      let e = await h({
        titulo: `Devolver la tarea`,
        mensaje: `${u.asignadoNombre || `El asignado`} va a ver este motivo.`,
        confirmarTexto: `Devolver`,
      });
      e &&
        Se(() =>
          api(`/tareas/${u.id}/devolver`, {
            method: `POST`,
            body: JSON.stringify({
              motivo: e,
              actorNombre: be,
            }),
          }),
        );
    },
    Ee = async () => {
      let e = await h({
        titulo: `Reabrir la tarea`,
        mensaje: `Queda en el historial de la tarea.`,
        confirmarTexto: `Reabrir`,
      });
      e &&
        Se(() =>
          api(`/tareas/${u.id}/reabrir`, {
            method: `POST`,
            body: JSON.stringify({
              motivo: e,
              actorNombre: be,
            }),
          }),
        );
    };
  function De(e) {
    v((t) =>
      t.asignados.some((t) => t.usuarioId === e.id)
        ? t
        : {
            ...t,
            asignados: [
              ...t.asignados,
              {
                usuarioId: e.id,
                nombre: e.nombre,
                correo: e.correo,
              },
            ],
          },
    );
  }
  function Oe(e) {
    v((t) => ({
      ...t,
      asignados: t.asignados.filter((t) => t.usuarioId !== e),
    }));
  }
  let [ke, Ae] = (0, React.useState)(!1),
    je = (e) =>
      Se(() =>
        api(`/tareas/${u.id}/redelegar`, {
          method: `POST`,
          body: JSON.stringify({
            asignadoUsuarioId: e.id,
            asignadoNombre: e.nombre,
            asignadoCorreo: e.correo,
            actorNombre: be,
          }),
        }),
      ),
    Me = p && !N && !M && (u.asignados ?? []).length > 0 && (R || z);
  async function Ne() {
    if (ue.trim()) {
      k(``);
      try {
        let e = await api(`/tareas/${u.id}/comprobantes`, {
          method: `POST`,
          body: JSON.stringify({
            url: ue.trim(),
            descripcion: fe.trim() || null,
            actorNombre: be,
          }),
        });
        (ie((t) => [...t, e]), de(``), pe(``));
      } catch (e) {
        k(e.message);
      }
    }
  }
  async function Pe(e) {
    try {
      (await api(`/tareas/${u.id}/comprobantes/${e}`, {
        method: `DELETE`,
      }),
        ie((t) => t.filter((t) => t.id !== e)));
    } catch (e) {
      k(e.message);
    }
  }
  let Fe = () =>
    he({
      fi: _.fechaInicio || ``,
      fv: _.fechaVencimiento || ``,
      motivo: ``,
      tipoCambio: `TARDANZA`,
    });
  async function Ie(e) {
    if ((e.preventDefault(), me?.motivo?.trim() && (me.fi || me.fv))) {
      k(``);
      try {
        let e = await api(`/tareas/${u.id}/solicitudes-fecha`, {
          method: `POST`,
          body: JSON.stringify({
            fechaInicio: me.fi || null,
            fechaVencimiento: me.fv || null,
            motivo: me.motivo,
            tipoCambio: me.tipoCambio,
            actorNombre: be,
          }),
        });
        (ae((t) => [e, ...t]), he(null));
      } catch (e) {
        k(e.message);
      }
    }
  }
  async function Le() {
    let e = await h({
      titulo: `Solicitar cancelación`,
      mensaje: `Lo va a ver quien te encargó la tarea, que decide si la cancela.`,
      confirmarTexto: `Enviar solicitud`,
    });
    if (e) {
      k(``);
      try {
        let t = await api(`/tareas/${u.id}/solicitudes-cancelacion`, {
          method: `POST`,
          body: JSON.stringify({
            motivo: e,
            actorNombre: be,
          }),
        });
        ae((e) => [t, ...e]);
      } catch (e) {
        k(e.message);
      }
    }
  }
  async function Re(e, t) {
    let n = null;
    (!t &&
      ((n = await h({
        titulo: `Rechazar la solicitud`,
        opcional: !0,
        confirmarTexto: `Rechazar`,
      })),
      n === null)) ||
      Se(() =>
        api(`/tareas/solicitudes-fecha/${e.id}/resolver`, {
          method: `POST`,
          body: JSON.stringify({
            aprobar: t,
            motivo: n,
            actorNombre: be,
          }),
        }),
      );
  }
  async function ze(t) {
    if ((t.preventDefault(), A || P || B)) return;
    (j(!0), k(``));
    let n = {
      ..._,
      metaId: _.metaId || null,
      listaId: _.listaId || null,
      fechaInicio: _.fechaInicio || null,
      fechaVencimiento: _.fechaVencimiento || null,
      menciones: b,
      actorNombre: obtenerUsuario()?.nombre,
    };
    try {
      if (p) {
        let e = await api(`/tareas/${u.id}`, {
          method: `PUT`,
          body: JSON.stringify(n),
          descripcion: `Cambios en «${_.titulo}»`,
        });
        g.ok(
          e?.guardadoSinConexion
            ? `Guardado en el teléfono — se envía al volver la señal`
            : `Cambios guardados`,
        );
      } else {
        let t = await api(`/tareas`, {
          method: `POST`,
          body: JSON.stringify(n),
          descripcion: `Tarea «${_.titulo}»`,
        });
        (e.id && ko(`CREAR_TAREA`, `TABLERO`, e.id),
          t?.guardadoSinConexion
            ? g.ok(`Tarea guardada en el teléfono — se crea al volver la señal`)
            : g.logro(
                `Tarea creada`,
                _.asignados.length
                  ? `${_.titulo} — para ${_.asignados[0].nombre?.split(` `)[0] ?? `la persona asignada`}`
                  : _.titulo,
                `arriba`,
              ));
      }
      (c(), s());
    } catch (e) {
      (k(e.message), j(!1), e.status === 409 && c());
    }
  }
  async function Be() {
    if (
      await m({
        titulo: `Cancelar la tarea`,
        mensaje: `Queda registrada como CANCELADA — no se elimina, para que el historial no se pierda.`,
        confirmarTexto: `Cancelar la tarea`,
        cancelarTexto: `Volver`,
        peligro: !0,
      })
    )
      try {
        (await api(`/tareas/${u.id}/cancelar`, {
          method: `POST`,
          body: JSON.stringify({
            actorNombre: obtenerUsuario()?.nombre,
          }),
        }),
          c(),
          s());
      } catch (e) {
        k(e.message);
      }
  }
  async function Ve(e) {
    if ((e.preventDefault(), w.trim()))
      try {
        let e = await api(`/tareas/${u.id}/comentarios`, {
          method: `POST`,
          body: JSON.stringify({
            cuerpo: w,
            autorNombre: obtenerUsuario()?.nombre,
            menciones: E,
          }),
        });
        (C((t) => [...t, e]), T(``), D([]));
      } catch (e) {
        k(e.message);
      }
  }
  let [He, Ue] = (0, React.useState)(``);
  async function We() {
    if (!He.trim()) return;
    let e = await api(`/tareas/${u.id}/checklist`, {
      method: `POST`,
      body: JSON.stringify({
        titulo: He,
      }),
    });
    (v((t) => ({
      ...t,
      checklist: [...(t.checklist ?? []), e],
    })),
      Ue(``));
  }
  async function Ge(e) {
    let t = (t) => ({
      ...t,
      checklist: t.checklist.map((t) =>
        t.id === e.id
          ? {
              ...t,
              hecho: !t.hecho,
            }
          : t,
      ),
    });
    v(t);
    try {
      await api(`/tareas/${u.id}/checklist/${e.id}`, {
        method: `PUT`,
        body: JSON.stringify({
          hecho: !e.hecho,
        }),
        descripcion: `«${e.titulo}» ${e.hecho ? `sin hacer` : `hecho`}`,
      });
    } catch (e) {
      (v(t), g.error(e.message));
    }
  }
  async function Ke(e) {
    (await api(`/tareas/${u.id}/checklist/${e.id}`, {
      method: `DELETE`,
    }),
      v((t) => ({
        ...t,
        checklist: t.checklist.filter((t) => t.id !== e.id),
      })));
  }
  let qe = (e) =>
    v((t) => ({
      ...t,
      etiquetaIds: t.etiquetaIds.includes(e)
        ? t.etiquetaIds.filter((t) => t !== e)
        : [...t.etiquetaIds, e],
    }));
  return ee ? (
    <Modal
      titulo={`Tarea`}
      onClose={s}
      ancho={`max-w-lg`}
      children={[
        l && <div className={`mb-3`} children={l} />,
        <ResumenTarea tarea={u} comprobantes={re} metas={r} listas={a} />,
        <div
          className={`mt-4 flex justify-end`}
          children={
            <button
              type={`button`}
              onClick={s}
              className={zo}
              children={`Cerrar`}
            />
          }
        />,
      ]}
    />
  ) : (
    <Modal
      titulo={p ? (B || N ? `Tarea` : `Editar tarea`) : `Nueva tarea`}
      onClose={s}
      ancho={`max-w-2xl`}
      children={[
        l && <div className={`mb-3`} children={l} />,
        N && L && !M && (
          <button
            type={`button`}
            onClick={Ee}
            className={`${zo} mb-3`}
            children={`Reabrir tarea`}
          />
        ),
        N && (
          <div
            className={`mb-3 flex items-start gap-2 rounded-2xl border border-(--border) bg-(--panel) px-3 py-2 text-sm text-(--text-h)`}
            children={[
              (0, JSXRuntime.jsx)(oi, {
                className: `mt-0.5 h-4 w-4 shrink-0 text-(--text)`,
              }),
              <span
                children={[
                  <span
                    className={`mr-1 rounded-full px-1.5 py-0.5 text-[10px] ${Qx(u.estado)}`}
                    children={Yx(u.estado)}
                  />,
                  `Esta tarea quedó como registro y ya no se puede editar ni eliminar`,
                  u.completadaEn && (
                    <JSXRuntime.Fragment
                      children={[` — se completó el `, pS(u.completadaEn)]}
                    />
                  ),
                  `.`,
                  u.conformidadEn && (
                    <JSXRuntime.Fragment
                      children={[
                        <br />,
                        `Aprobada por `,
                        <strong
                          children={
                            u.conformidadPorNombre || `quien la encargó`
                          }
                        />,
                        ` el `,
                        pS(u.conformidadEn),
                        u.horasEsperaConformidad != null &&
                          ` · esperó ${zx(u.horasEsperaConformidad)}`,
                      ]}
                    />
                  ),
                ]}
              />,
            ]}
          />
        ),
        B && (
          <p
            className={`mb-3 rounded-2xl border border-(--info-border) bg-(--info-bg) px-3 py-2 text-sm text-(--text-h)`}
            children={[
              `Te la encargó `,
              <strong children={u.creadoPorNombre || `otra persona`} />,
              `. Cuando la termines, la revisa.`,
            ]}
          />
        ),
        p && u.necesitaConforme && z && !N && (
          <div
            className={`mb-3 flex flex-wrap items-center gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) px-3 py-2 text-sm text-(--text-h)`}
            children={
              u.estado === `EN_REVISION` ? (
                <JSXRuntime.Fragment
                  children={[
                    <span
                      className={`flex-1`}
                      children={[
                        !L && (
                          <span
                            className={`font-medium`}
                            children={`Como responsable del área: `}
                          />
                        ),
                        u.asignadoNombre || `El asignado`,
                        ` marcó la tarea completada. Revisá el sustento y:`,
                      ]}
                    />,
                    <AccionAsync
                      onClick={we}
                      icono={Nr}
                      textoOcupado={`Aprobando…`}
                      className={`px-3 py-1.5 text-xs`}
                      children={`Dar conformidad`}
                    />,
                    <AccionAsync
                      onClick={Te}
                      variante={`secundario`}
                      icono={Yi}
                      className={`px-3 py-1.5 text-xs`}
                      children={`Devolver`}
                    />,
                  ]}
                />
              ) : null
            }
          />
        ),
        p && !N && (
          <div
            className={`mb-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-(--text)`}
            children={[
              <span
                className={`rounded-full px-2 py-0.5 text-[11px] ${Qx(u.estado)}`}
                children={Yx(u.estado)}
              />,
              !B && !te && u.creadoPorNombre && (
                <span children={[`La encargó `, u.creadoPorNombre]} />
              ),
              u.fechaVencimiento && (
                <span children={[`· Entrega `, fS(u.fechaVencimiento)]} />
              ),
              u.atrasada && (
                <span
                  className={`font-medium text-(--error)`}
                  children={`· Atrasada`}
                />
              ),
            ]}
          />
        ),
        <form
          onSubmit={ze}
          className={`flex flex-col gap-3`}
          children={[
            <input
              className={Lo}
              placeholder={`Título`}
              value={_.titulo}
              onChange={(e) => ye(`titulo`, e.target.value)}
              required={!0}
              autoFocus={!B}
              disabled={V}
            />,
            <EditorMenciones
              value={_.descripcion || ``}
              onChange={(e) => ye(`descripcion`, e)}
              onMenciones={x}
              miembros={F}
              placeholder={`Descripcion — escribe @ para mencionar`}
              className={`${Lo} min-h-20`}
              disabled={V}
            />,
            <div
              className={`grid grid-cols-2 gap-3`}
              children={[
                <Componente_zS_122_83
                  label={`Inicio`}
                  children={
                    B ? (
                      <Componente_BS_66_83
                        valor={_.fechaInicio}
                        pendiente={ve}
                        onPedir={Fe}
                      />
                    ) : (
                      <SelectorFecha
                        value={_.fechaInicio || ``}
                        min={p ? void 0 : NS}
                        onChange={(e) => ye(`fechaInicio`, e)}
                        disabled={V}
                      />
                    )
                  }
                />,
                <Componente_zS_122_83
                  label={`Entrega`}
                  children={
                    B ? (
                      <Componente_BS_66_83
                        valor={_.fechaVencimiento}
                        pendiente={ve}
                        onPedir={Fe}
                      />
                    ) : (
                      <SelectorFecha
                        value={_.fechaVencimiento || ``}
                        min={_.fechaInicio || void 0}
                        onChange={(e) => ye(`fechaVencimiento`, e || PS)}
                        disabled={V}
                      />
                    )
                  }
                />,
                <Componente_zS_122_83
                  label={`Prioridad`}
                  children={
                    <SelectorMultiple
                      value={_.prioridad}
                      onChange={(e) => ye(`prioridad`, e || `MEDIA`)}
                      placeholder={`Prioridad`}
                      disabled={V}
                      opciones={Fx.map((e) => ({
                        value: e.codigo,
                        label: e.label,
                      }))}
                    />
                  }
                />,
                <Componente_zS_122_83
                  label={`Repetir`}
                  children={
                    <SelectorMultiple
                      value={_.recurrencia}
                      onChange={(e) => ye(`recurrencia`, e || `NINGUNA`)}
                      placeholder={`No se repite`}
                      disabled={V}
                      opciones={Ix.filter((e) => e.codigo !== `NINGUNA`).map(
                        (e) => ({
                          value: e.codigo,
                          label: e.label,
                        }),
                      )}
                    />
                  }
                />,
                r.length > 0 && (
                  <Componente_zS_122_83
                    label={`Meta`}
                    children={
                      <SelectorMultiple
                        value={_.metaId ? String(_.metaId) : ``}
                        onChange={(e) => ye(`metaId`, e)}
                        placeholder={`— Sin meta —`}
                        disabled={V}
                        opciones={r.map((e) => ({
                          value: String(e.id),
                          label: e.titulo,
                        }))}
                      />
                    }
                  />
                ),
                a.length > 0 && (
                  <Componente_zS_122_83
                    label={`Lista`}
                    children={
                      <SelectorMultiple
                        value={_.listaId ? String(_.listaId) : ``}
                        onChange={(e) => ye(`listaId`, e)}
                        placeholder={`— Sin lista —`}
                        disabled={V}
                        opciones={a.map((e) => ({
                          value: String(e.id),
                          label: e.nombre,
                        }))}
                      />
                    }
                  />
                ),
              ]}
            />,
            _.recurrencia !== `NINGUNA` && !B && (
              <p
                className={`text-xs text-(--text)`}
                children={`Al completarla se crea sola la siguiente ocurrencia, con las fechas corridas.`}
              />
            ),
            B && ve && (
              <p
                className={`rounded-2xl border border-(--warning-border) bg-(--warning-bg) px-3 py-2 text-xs text-(--text-h)`}
                children={[
                  (0, JSXRuntime.jsx)(wr, {
                    className: `mr-1 inline h-3.5 w-3.5`,
                  }),
                  `Pediste `,
                  ve.tipo === `CANCELACION`
                    ? `cancelar la tarea`
                    : `un cambio de fecha`,
                  ` — esperá la respuesta de quien te la encargó.`,
                ]}
              />
            ),
            B && me && (
              <div
                className={`flex flex-col gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) p-3`}
                children={[
                  <p
                    className={`text-xs font-medium text-(--text-h)`}
                    children={`Pedir otras fechas`}
                  />,
                  <div
                    className={`grid gap-2 sm:grid-cols-2`}
                    children={[
                      <SelectorFecha
                        value={me.fi}
                        placeholder={`Inicio`}
                        onChange={(e) =>
                          he((t) => ({
                            ...t,
                            fi: e,
                          }))
                        }
                      />,
                      <SelectorFecha
                        value={me.fv}
                        placeholder={`Vencimiento`}
                        min={me.fi || void 0}
                        onChange={(e) =>
                          he((t) => ({
                            ...t,
                            fv: e,
                          }))
                        }
                      />,
                    ]}
                  />,
                  <SelectorMultiple
                    value={me.tipoCambio}
                    onChange={(e) =>
                      he((t) => ({
                        ...t,
                        tipoCambio: e,
                      }))
                    }
                    opciones={Bx}
                  />,
                  <input
                    className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                    placeholder={`¿Por qué? (lo lee quien te la encargó)`}
                    value={me.motivo}
                    onChange={(e) =>
                      he((t) => ({
                        ...t,
                        motivo: e.target.value,
                      }))
                    }
                  />,
                  <div
                    className={`flex flex-col-reverse gap-2 sm:flex-row sm:justify-end`}
                    children={[
                      <button
                        type={`button`}
                        onClick={() => he(null)}
                        className={zo}
                        children={`Descartar`}
                      />,
                      <button
                        type={`button`}
                        onClick={Ie}
                        className={Ro}
                        children={`Enviar pedido`}
                      />,
                    ]}
                  />,
                ]}
              />
            ),
            i.length > 0 && (_.etiquetaIds.length > 0 || !V) && (
              <Componente_zS_122_83
                label={`Etiquetas`}
                children={
                  <div
                    className={`flex flex-wrap gap-1.5`}
                    children={i
                      .filter((e) => !V || _.etiquetaIds.includes(e.id))
                      .map((e) => {
                        let t = _.etiquetaIds.includes(e.id);
                        return (
                          <button
                            key={e.id}
                            type={`button`}
                            disabled={V}
                            onClick={() => qe(e.id)}
                            aria-pressed={t}
                            className={`rounded-full px-2 py-0.5 text-xs transition disabled:cursor-default ${t ? `` : `text-(--text) opacity-60`}`}
                            style={
                              t
                                ? rS(e)
                                : {
                                    background: `transparent`,
                                    border: `1px solid ${e.color || ``}`,
                                  }
                            }
                            children={e.nombre}
                          />
                        );
                      })}
                  />
                }
              />
            ),
            e.esMiEspacioPersonal ? null : (
              <Componente_zS_122_83
                label={_.asignados.length > 1 ? `Asignada a` : `Asignado a`}
                children={[
                  _.asignados.length > 0 && (
                    <ul
                      className={`mb-2 flex flex-col gap-1.5`}
                      children={_.asignados.map((e) => (
                        <li
                          key={e.usuarioId}
                          className={`flex items-center gap-2 rounded-2xl border border-(--border) px-3 py-2 text-sm text-(--text-h)`}
                          children={[
                            <span
                              className={`flex-1 truncate`}
                              children={e.nombre || `Usuario ${e.usuarioId}`}
                            />,
                            !V && (
                              <button
                                type={`button`}
                                onClick={() => Oe(e.usuarioId)}
                                aria-label={`Quitar a ${e.nombre || e.usuarioId}`}
                                className={`text-(--text) hover:text-(--error)`}
                                children={(0, JSXRuntime.jsx)(ra, {
                                  className: `h-4 w-4`,
                                })}
                              />
                            ),
                          ]}
                        />
                      ))}
                    />
                  ),
                  !V && (
                    <BuscadorPersona
                      placeholder={
                        _.asignados.length
                          ? `Asignar a alguien más…`
                          : `Asignar a…`
                      }
                      excluirIds={[
                        ..._.asignados.map((e) => e.usuarioId),
                        ...H,
                      ]}
                      onSelect={De}
                    />
                  ),
                  Me && (
                    <div
                      className={`mt-2`}
                      children={
                        ke ? (
                          <div
                            className={`rounded-2xl border border-(--border) p-2`}
                            children={[
                              <p
                                className={`mb-1.5 text-xs text-(--text)`}
                                children={[
                                  `Pasale la tarea a alguien de tu equipo. `,
                                  R &&
                                    `Vos le das el visto bueno cuando la termine.`,
                                ]}
                              />,
                              <BuscadorPersona
                                placeholder={`Re-delegar a…`}
                                excluirIds={H}
                                onSelect={je}
                              />,
                              <button
                                type={`button`}
                                onClick={() => Ae(!1)}
                                className={`mt-1.5 text-xs text-(--text) hover:text-(--text-h)`}
                                children={`Cancelar`}
                              />,
                            ]}
                          />
                        ) : (
                          <button
                            type={`button`}
                            onClick={() => Ae(!0)}
                            className={`text-xs font-medium text-(--accent) hover:underline`}
                            children={`Re-delegar a otra persona`}
                          />
                        )
                      }
                    />
                  ),
                ]}
              />
            ),
            o.length > 0 && (_.dependeDe?.length > 0 || !V) && (
              <Componente_zS_122_83
                label={`Depende de (Gantt)`}
                children={
                  <div
                    className={`flex flex-wrap gap-1.5`}
                    children={o
                      .filter((e) => !u || e.id !== u.id)
                      .filter((e) => !V || (_.dependeDe || []).includes(e.id))
                      .map((e) => {
                        let t = (_.dependeDe || []).includes(e.id);
                        return (
                          <button
                            key={e.id}
                            type={`button`}
                            disabled={V}
                            onClick={() =>
                              ye(
                                `dependeDe`,
                                t
                                  ? _.dependeDe.filter((t) => t !== e.id)
                                  : [...(_.dependeDe || []), e.id],
                              )
                            }
                            className={`rounded-full border px-2 py-0.5 text-xs transition disabled:cursor-default ${t ? `border-(--accent) bg-(--accent-bg) text-(--accent)` : `border-(--border) text-(--text)`}`}
                            children={e.titulo}
                          />
                        );
                      })}
                  />
                }
              />
            ),
            (_.reunionOrigenTitulo || _.discusionOrigenTitulo) && (
              <p
                className={`rounded-2xl bg-(--accent-bg) px-3 py-2 text-xs text-(--text-h)`}
                children={[
                  _.reunionOrigenTitulo && (
                    <JSXRuntime.Fragment
                      children={[
                        `Se planteo en la reunion: `,
                        <strong children={_.reunionOrigenTitulo} />,
                      ]}
                    />
                  ),
                  _.discusionOrigenTitulo && (
                    <JSXRuntime.Fragment
                      children={[
                        `Salio de la discusion: `,
                        <strong children={_.discusionOrigenTitulo} />,
                      ]}
                    />
                  ),
                ]}
              />
            ),
            O && <p className={`text-sm text-(--error)`} children={O} />,
            ge && (
              <ConfirmarFechaTerminada
                onConfirmar={(e) => {
                  let t = ge;
                  (_e(null), Ce(t.estado, e));
                }}
                onDescartar={() => _e(null)}
              />
            ),
            <div
              className={`flex flex-col gap-2 border-t border-(--border) pt-3 sm:flex-row sm:items-center sm:justify-between`}
              children={[
                p && !P && !B ? (
                  <button
                    type={`button`}
                    onClick={Be}
                    className={`text-sm font-medium text-(--error) hover:underline sm:order-1`}
                    children={[
                      (0, JSXRuntime.jsx)(yr, {
                        className: `mr-1 inline h-3.5 w-3.5`,
                      }),
                      ` Cancelar tarea`,
                    ]}
                  />
                ) : B && !ve ? (
                  <button
                    type={`button`}
                    onClick={Le}
                    className={`text-sm font-medium text-(--error) hover:underline sm:order-1`}
                    children={[
                      (0, JSXRuntime.jsx)(yr, {
                        className: `mr-1 inline h-3.5 w-3.5`,
                      }),
                      ` Pedir que la cancelen`,
                    ]}
                  />
                ) : (
                  <span className={`sm:order-1`} />
                ),
                <div
                  className={`flex flex-col-reverse gap-2 sm:order-2 sm:flex-row sm:items-center`}
                  children={[
                    !P &&
                      !B &&
                      (p ? (
                        <SelectorMultiple
                          value={u.estado}
                          onChange={(e) => {
                            e &&
                              e !== u.estado &&
                              (e === `COMPLETADA` && !u.necesitaConforme
                                ? _e({
                                    estado: e,
                                  })
                                : Ce(e));
                          }}
                          placeholder={`Estado`}
                          opciones={Nx.map((e) => ({
                            value: e.codigo,
                            label: e.label,
                          }))}
                        />
                      ) : (
                        <SelectorMultiple
                          value={_.estado}
                          onChange={(e) => ye(`estado`, e || `POR_HACER`)}
                          placeholder={`Estado`}
                          opciones={Nx.map((e) => ({
                            value: e.codigo,
                            label: e.label,
                          }))}
                        />
                      )),
                    <button
                      type={`button`}
                      onClick={s}
                      className={zo}
                      children={`Cerrar`}
                    />,
                    B ? (
                      <AccionesEstadoTarea
                        tarea={u}
                        comprobantes={re}
                        onMover={Ce}
                        onPedirDia={(e) =>
                          _e({
                            estado: e,
                          })
                        }
                      />
                    ) : (
                      !P && (
                        <AccionAsync
                          type={`submit`}
                          ocupado={A}
                          textoOcupado={p ? `Guardando…` : `Creando…`}
                          children={p ? `Guardar` : `Crear`}
                        />
                      )
                    ),
                  ]}
                />,
              ]}
            />,
          ]}
        />,
        p && (
          <div
            className={`mt-6 flex flex-col gap-5 border-t border-(--border) pt-4`}
            children={[
              <div
                children={[
                  <p
                    className={`text-sm font-medium text-(--text-h)`}
                    children={[
                      `Checklist `,
                      _.checklist?.length > 0 &&
                        `(${_.checklist.filter((e) => e.hecho).length}/${_.checklist.length})`,
                    ]}
                  />,
                  <ul
                    className={`mt-2 flex flex-col gap-1`}
                    children={(_.checklist ?? []).map((e) => (
                      <li
                        key={e.id}
                        className={`flex items-center gap-2 text-sm`}
                        children={[
                          <MarcaCarga
                            checked={e.hecho}
                            onChange={() => Ge(e)}
                            disabled={P}
                          />,
                          <span
                            className={`flex-1 ${e.hecho ? `text-(--text) line-through` : `text-(--text-h)`}`}
                            children={e.titulo}
                          />,
                          !P && !B && (
                            <button
                              type={`button`}
                              onClick={() => Ke(e)}
                              className={`text-(--text) hover:text-(--error)`}
                              children={(0, JSXRuntime.jsx)(ra, {
                                className: `h-3.5 w-3.5`,
                              })}
                            />
                          ),
                        ]}
                      />
                    ))}
                  />,
                  !P && !B && (
                    <div
                      className={`mt-2 flex gap-2`}
                      children={[
                        <input
                          className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                          placeholder={`Nuevo item…`}
                          value={He}
                          onChange={(e) => Ue(e.target.value)}
                          onKeyDown={(e) =>
                            e.key === `Enter` && (e.preventDefault(), We())
                          }
                        />,
                        <button
                          type={`button`}
                          onClick={We}
                          className={zo}
                          children={`Agregar`}
                        />,
                      ]}
                    />
                  ),
                ]}
              />,
              <Componente_LS_76_83
                titulo={`Comprobantes`}
                aclaracion={`sustento de lo hecho (ej. un correo)`}
                cuenta={re.length}
                abiertaInicial={B && re.length === 0}
                children={[
                  <ul
                    className={`mt-2 flex flex-col gap-1`}
                    children={[
                      re.map((e) => (
                        <li
                          key={e.id}
                          className={`flex items-center gap-2 rounded-xl border border-(--border) px-2 py-1.5 text-sm`}
                          children={[
                            (0, JSXRuntime.jsx)($r, {
                              className: `h-3.5 w-3.5 shrink-0 text-(--text)`,
                            }),
                            <a
                              href={e.url}
                              target={`_blank`}
                              rel={`noreferrer`}
                              className={`min-w-0 flex-1 truncate text-(--accent) hover:underline`}
                              children={e.descripcion || e.url}
                            />,
                            <span
                              className={`shrink-0 text-[11px] text-(--text)`}
                              children={e.agregadoPorNombre?.split(` `)[0]}
                            />,
                            !N && (
                              <button
                                type={`button`}
                                onClick={() => Pe(e.id)}
                                className={`shrink-0 text-(--text) hover:text-(--error)`}
                                children={(0, JSXRuntime.jsx)(ra, {
                                  className: `h-3.5 w-3.5`,
                                })}
                              />
                            ),
                          ]}
                        />
                      )),
                      re.length === 0 && (
                        <li
                          className={`text-xs text-(--text)`}
                          children={`Sin comprobantes.`}
                        />
                      ),
                    ]}
                  />,
                  !P && (
                    <div
                      className={`mt-2 flex flex-col gap-2 sm:flex-row`}
                      children={[
                        <input
                          className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                          placeholder={`https://… o mailto:…`}
                          value={ue}
                          onChange={(e) => de(e.target.value)}
                        />,
                        <input
                          className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) sm:max-w-[40%]`}
                          placeholder={`Descripción (opcional)`}
                          value={fe}
                          onChange={(e) => pe(e.target.value)}
                        />,
                        <button
                          type={`button`}
                          onClick={Ne}
                          className={zo}
                          children={`Agregar`}
                        />,
                      ]}
                    />
                  ),
                ]}
              />,
              U.length > 0 && !B && (
                <div
                  children={[
                    <p
                      className={`text-sm font-medium text-(--text-h)`}
                      children={`Solicitudes del asignado`}
                    />,
                    <ul
                      className={`mt-2 flex flex-col gap-2`}
                      children={U.map((e) => (
                        <li
                          key={e.id}
                          className={`rounded-2xl border border-(--border) px-3 py-2 text-sm`}
                          children={[
                            <div
                              className={`flex items-center gap-2`}
                              children={[
                                <span
                                  className={`rounded-full px-1.5 py-0.5 text-[10px] ${Qx(e.estado === `APROBADA` ? `COMPLETADA` : e.estado === `RECHAZADA` ? `CANCELADA` : `EN_RIESGO`)}`}
                                  children={
                                    e.estado === `PENDIENTE`
                                      ? `Pendiente`
                                      : e.estado === `APROBADA`
                                        ? `Aprobada`
                                        : `Rechazada`
                                  }
                                />,
                                <span
                                  className={`flex-1 text-(--text-h)`}
                                  children={e.solicitanteNombre || `Alguien`}
                                />,
                                <span
                                  className={`text-xs text-(--text)`}
                                  children={pS(e.creadoEn)}
                                />,
                              ]}
                            />,
                            <p
                              className={`mt-1 text-xs text-(--text)`}
                              children={
                                e.tipo === `CANCELACION`
                                  ? `Pide cancelar la tarea (queda como registro, no se borra)`
                                  : `Propone: ${e.fechaInicioPropuesta ? `inicio ${e.fechaInicioPropuesta}` : ``} ${e.fechaVencimientoPropuesta ? `venc. ${e.fechaVencimientoPropuesta}` : ``}`
                              }
                            />,
                            <p
                              className={`mt-0.5 whitespace-pre-wrap text-(--text-h)`}
                              children={e.motivo}
                            />,
                            e.respuestaMotivo && (
                              <p
                                className={`mt-0.5 text-xs text-(--text)`}
                                children={[`Respuesta: `, e.respuestaMotivo]}
                              />
                            ),
                            e.estado === `PENDIENTE` && z && (
                              <div
                                className={`mt-2 flex gap-2`}
                                children={[
                                  <button
                                    type={`button`}
                                    onClick={() => Re(e, !0)}
                                    className={Ro}
                                    children={`Aprobar`}
                                  />,
                                  <button
                                    type={`button`}
                                    onClick={() => Re(e, !1)}
                                    className={zo}
                                    children={`Rechazar`}
                                  />,
                                ]}
                              />
                            ),
                          ]}
                        />
                      ))}
                    />,
                  ]}
                />
              ),
              !y && (
                <ListaAdjuntos
                  entidadTipo={`TAREA`}
                  entidadId={u.id}
                  soloLectura={P || B}
                />
              ),
              <Componente_LS_76_83
                titulo={`Comentarios`}
                cuenta={S.length}
                abiertaInicial={S.length > 0 && S.length <= 3}
                children={[
                  <ul
                    className={`mt-2 flex flex-col gap-2`}
                    children={[
                      S.map((e) => (
                        <li
                          key={e.id}
                          className={`rounded-2xl bg-(--panel) px-3 py-2 text-sm`}
                          children={[
                            <p
                              className={`whitespace-pre-wrap text-(--text-h)`}
                              children={e.cuerpo}
                            />,
                            <p
                              className={`mt-0.5 text-xs text-(--text)`}
                              children={[
                                e.autorNombre || `Alguien`,
                                ` · `,
                                pS(e.creadoEn),
                              ]}
                            />,
                          ]}
                        />
                      )),
                      S.length === 0 && (
                        <li
                          className={`text-xs text-(--text)`}
                          children={`Sin comentarios.`}
                        />
                      ),
                    ]}
                  />,
                  !M && (
                    <form
                      onSubmit={Ve}
                      className={`mt-2 flex flex-col gap-2`}
                      children={[
                        <EditorMenciones
                          value={w}
                          onChange={T}
                          onMenciones={D}
                          miembros={F}
                          rows={2}
                          placeholder={`Escribe un comentario — @ para mencionar`}
                          className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) min-h-14`}
                        />,
                        <div
                          className={`flex justify-end`}
                          children={
                            <button
                              type={`submit`}
                              className={zo}
                              children={`Enviar`}
                            />
                          }
                        />,
                      ]}
                    />
                  ),
                ]}
              />,
              <div
                children={[
                  <button
                    type={`button`}
                    onClick={() => le((e) => !e)}
                    className={`flex items-center gap-1 text-sm font-medium text-(--text-h)`}
                    children={[
                      <Ar
                        className={`h-4 w-4 transition ${ce ? `rotate-180` : ``}`}
                      />,
                      `Historial completo`,
                    ]}
                  />,
                  ce && (
                    <ul
                      className={`mt-2 flex flex-col gap-1 border-l border-(--border) pl-3 text-xs`}
                      children={[
                        oe.map((e) => (
                          <li
                            key={e.id}
                            className={`text-(--text)`}
                            children={[
                              <span
                                className={`text-(--text-h)`}
                                children={e.actorNombre || `Alguien`}
                              />,
                              ` — `,
                              lS(e.accion),
                              e.campo && e.valorAntes != null && (
                                <JSXRuntime.Fragment
                                  children={[
                                    ` (`,
                                    e.campo,
                                    `: `,
                                    e.valorAntes,
                                    ` → `,
                                    e.valorDespues,
                                    `)`,
                                  ]}
                                />
                              ),
                              e.detalle && (
                                <JSXRuntime.Fragment
                                  children={[` · `, e.detalle]}
                                />
                              ),
                              <span
                                className={`ml-1 text-(--text)/70`}
                                children={pS(e.en)}
                              />,
                            ]}
                          />
                        )),
                        oe.length === 0 && (
                          <li
                            className={`text-(--text)`}
                            children={`Sin movimientos.`}
                          />
                        ),
                      ]}
                    />
                  ),
                ]}
              />,
            ]}
          />
        ),
      ]}
    />
  );
}
